export const IssuesTableHeader = ({ handleSort }) => {
  return (
    <thead className="table-dark rounded-top">
      <tr>
        <th onClick={() => handleSort('Issue.ID')}>ISSUE Nº</th>
        <th onClick={() => handleSort('createdAt')}>TIME</th>
        <th onClick={() => handleSort('Issue.definition')}>ISSUE</th>
        <th onClick={() => handleSort('Installation.Dev_type')}>DEVICE</th>
      </tr>
    </thead>
  );
};